namespace SorAraBul.PropertyManagement {
    export interface TenantWizardForm {
        SelfReportedEmail: Serenity.EmailAddressEditor;
        TcknInput: Common.TcknEditor;
        SelfReportedName: Serenity.StringEditor;
        SelfReportedSurname: Serenity.StringEditor;
        SelfReportedPhone: Common.PhoneEditor;
        BirthDate: Serenity.DateEditor;
        TermsAccepted: Serenity.BooleanEditor;
        PropertyType: CustomStaticTextBlock;
        PropertyName: Serenity.Extensions.StaticTextBlock;
        PropertyRequestedRentAmountWithCurrency: Serenity.Extensions.StaticTextBlock;
        PropertyCityName: Serenity.Extensions.StaticTextBlock;
        PropertyTownName: Serenity.Extensions.StaticTextBlock;
        PropertyQuarterName: Serenity.Extensions.StaticTextBlock;
        PropertyAddress: Serenity.Extensions.StaticTextBlock;
        PropertyRestrictions: Serenity.Extensions.StaticTextBlock;
        TenantName: Serenity.Extensions.StaticTextBlock;
        TenantSurname: Serenity.Extensions.StaticTextBlock;
        TenantPhone: Serenity.Extensions.StaticTextBlock;
        TenantEmail: Serenity.Extensions.StaticTextBlock;
        MaritalStatus: Serenity.EnumEditor;
        HasChildren: YesNoEditor;
        ChildrenCount: Serenity.IntegerEditor;
        ChildrenAges: Serenity.StringEditor;
        WorkingAdultsCount: Serenity.IntegerEditor;
        OccupationSelfId: Serenity.ServiceLookupEditor;
        OccupationSelf: Serenity.StringEditor;
        OccupationSpouseId: Serenity.ServiceLookupEditor;
        OccupationSpouse: Serenity.StringEditor;
        EducationLevelSelf: Serenity.EnumEditor;
        EducationLevelSpouse: Serenity.EnumEditor;
        HasPet: YesNoEditor;
        PetTypes: Serenity.LookupEditor;
        Text: Serenity.Extensions.StaticTextBlock;
        OldCityId: Serenity.ServiceLookupEditor;
        OldTownId: Serenity.ServiceLookupEditor;
        OldQuarterId: Serenity.ServiceLookupEditor;
        OldAddress: Serenity.StringEditor;
        OldAddressResidenceDurationYears: Serenity.IntegerEditor;
        OldAddressResidenceDurationRemainingMonths: Serenity.IntegerEditor;
    }

    export class TenantWizardForm extends Serenity.PrefixedContext {
        static formKey = 'PropertyManagement.TenantWizardForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TenantWizardForm.init)  {
                TenantWizardForm.init = true;

                var s = Serenity;
                var w0 = s.EmailAddressEditor;
                var w1 = Common.TcknEditor;
                var w2 = s.StringEditor;
                var w3 = Common.PhoneEditor;
                var w4 = s.DateEditor;
                var w5 = s.BooleanEditor;
                var w6 = CustomStaticTextBlock;
                var w7 = s.Extensions.StaticTextBlock;
                var w8 = s.EnumEditor;
                var w9 = YesNoEditor;
                var w10 = s.IntegerEditor;
                var w11 = s.ServiceLookupEditor;
                var w12 = s.LookupEditor;

                Q.initFormType(TenantWizardForm, [
                    'SelfReportedEmail', w0,
                    'TcknInput', w1,
                    'SelfReportedName', w2,
                    'SelfReportedSurname', w2,
                    'SelfReportedPhone', w3,
                    'BirthDate', w4,
                    'TermsAccepted', w5,
                    'PropertyType', w6,
                    'PropertyName', w7,
                    'PropertyRequestedRentAmountWithCurrency', w7,
                    'PropertyCityName', w7,
                    'PropertyTownName', w7,
                    'PropertyQuarterName', w7,
                    'PropertyAddress', w7,
                    'PropertyRestrictions', w7,
                    'TenantName', w7,
                    'TenantSurname', w7,
                    'TenantPhone', w7,
                    'TenantEmail', w7,
                    'MaritalStatus', w8,
                    'HasChildren', w9,
                    'ChildrenCount', w10,
                    'ChildrenAges', w2,
                    'WorkingAdultsCount', w10,
                    'OccupationSelfId', w11,
                    'OccupationSelf', w2,
                    'OccupationSpouseId', w11,
                    'OccupationSpouse', w2,
                    'EducationLevelSelf', w8,
                    'EducationLevelSpouse', w8,
                    'HasPet', w9,
                    'PetTypes', w12,
                    'Text', w7,
                    'OldCityId', w11,
                    'OldTownId', w11,
                    'OldQuarterId', w11,
                    'OldAddress', w2,
                    'OldAddressResidenceDurationYears', w10,
                    'OldAddressResidenceDurationRemainingMonths', w10
                ]);
            }
        }
    }
}
